(function() {
    window.api_url = 'http://gateway.upvarejo.com.br';
    window.base_url = 'http://sistema.uparejo.com.br';
})()
